/** selectionBox组件 弹窗类型
 * - 0 单选框类型带叉号
 * - 1 picker带确定取消
 * - 2 cell带标题类型且带叉号
 * - 3 cell不带标题类型且带叉号
 * - 4 页面跳转选择
 * - 5 无弹窗
 * - 6 自定义内容带叉号
 * */
export enum SELECTION_BOX_POP_TYPE {
  RADIO_POP,
  PICKER_POP,
  CELL_TITLE_POP,
  CELL_POP,
  PAGE_JUMP,
  NO_TYPE,
  DEFINE_COMPONENT
}
